import { styled } from "@mui/material";

export const AgreementModalRoot = styled("div")`
    max-height: 700px;
    max-width: 680px;
`;

export default AgreementModalRoot;
